import { useState, useEffect } from 'react'
import PubSub from 'pubsub-js'

import { Quote } from '../types'

import { join } from '../libraries'
import useCustomSearchParams from "./useCustomSearchParams";
import useStock from "./useStock";
import {useChartStockCode} from "../../@shared/stores/chartStore";

const useQuote = (initialCode?: string) => {
  const { getParams } = useCustomSearchParams()
  const stock = useStock()

  const [quote, setQuote] = useState<Quote | null>(null)
  const {stockCode} = useChartStockCode()

  const code =
    initialCode ||
    (stock.state === 'loading'
      ? (getParams('code', DEFAULT_CODE) || stockCode)
      : stock.contents.code)

  useEffect(() => {
    const token = PubSub.subscribe(code, (msg: string, quote: Quote) => {
      if (quote.gBoard !== 'REGULAR_HOURS') return

      setQuote({ ...quote })
    })

    join(code)

    return () => {
      PubSub.unsubscribe(token)
    }
  }, [code])

  return quote
}

export default useQuote

const DEFAULT_CODE = 'KR7005930003'
